module.exports = __webpack_public_path__ + "fonts/fa-solid-900.4451e1d8.woff";